import React from "react";
// import AdCard from "../../templates/AdCard"; // Commented out for Auto Ads setup

function About() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-indigo-50 via-white to-gray-100 px-4 py-16">
      {/* ===== Top Section ===== */}
      <div className="max-w-5xl mx-auto text-center mb-16">
        <h1 className="text-5xl sm:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 via-purple-500 to-pink-500 mb-4 animate-fadeIn mt-10">
          About JobIntelPro
        </h1>
        <p className="text-gray-600 text-lg sm:text-xl max-w-3xl mx-auto animate-fadeInSlow">
          Empowering job seekers and employers with a smarter, faster, and more
          connected way to find opportunities and talent.
        </p>
      </div>

      {/* ===== Main Content Card ===== */}
      <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-2xl p-8 sm:p-12 transition-all duration-300 hover:shadow-[0_10px_50px_rgba(99,102,241,0.15)]">
        <div className="space-y-8 text-gray-800 text-lg sm:text-xl leading-relaxed">
          <p>
            <strong className="text-indigo-600">JobIntelPro</strong> is your
            all-in-one platform for exploring diverse career opportunities and
            connecting with top companies globally. Our intuitive interface
            ensures a seamless experience for job seekers and employers alike.
          </p>

          <p>
            Whether you’re a{" "}
            <span className="font-semibold text-indigo-700">
              fresh graduate
            </span>
            , an{" "}
            <span className="font-semibold text-indigo-700">
              experienced professional
            </span>
            , or a{" "}
            <span className="font-semibold text-indigo-700">recruiter</span>,
            JobIntelPro simplifies the process of finding and posting jobs —
            making it faster, smarter, and more efficient.
          </p>

          <div className="bg-gradient-to-r from-indigo-100 to-purple-100 rounded-2xl p-6 border-l-8 border-indigo-500">
            <h2 className="text-2xl font-bold text-indigo-700 mb-2">
              Our Mission
            </h2>
            <p>
              To bridge the gap between talent and opportunity by building a
              trusted, inclusive, and innovative platform that empowers
              individuals to achieve their professional dreams and helps
              organizations grow with the right talent.
            </p>
          </div>

          <p className="text-indigo-700 font-semibold text-xl text-center">
            Start exploring today, discover your next career move, and let{" "}
            <span className="underline decoration-pink-400 decoration-2 underline-offset-4">
              JobIntelPro
            </span>{" "}
            guide you toward a brighter professional future.
          </p>
        </div>
      </div>

      {/* ===== Optional Footer Ad (commented for Auto Ads) ===== */}
      {/* 
      <div className="max-w-5xl mx-auto mt-12">
        <AdCard
          size="medium"
          className="w-full h-64 rounded-2xl shadow-md bg-gradient-to-r from-indigo-600 to-teal-500 text-white flex items-center justify-center"
        />
      </div>
      */}

      {/* ===== Subtle Footer Info ===== */}
      <div className="max-w-5xl mx-auto text-center mt-16 text-gray-500 text-sm">
        © {new Date().getFullYear()} JobIntelPro — All Rights Reserved.
      </div>
    </div>
  );
}

export default About;
